"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CardCarousel;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _index = _interopRequireDefault(require("../../elements/other/headline-lockup/index.js"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _functions = require("./functions");
var _CarouselControls = _interopRequireDefault(require("./CarouselControls"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const CarouselHeader = /*#__PURE__*/(0, _react2.styled)("header")({
  name: "CarouselHeader",
  class: "pl-c18mkjfw"
});
const StyledCarouselControls = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "StyledCarouselControls",
  class: "pl-spg25s6"
});
const CarouselWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CarouselWrapper",
  class: "pl-c1a90m2l",
  vars: {
    "c1a90m2l-6": [({
      showMobileControls
    }) => showMobileControls ? 'inline-flex' : 'flex']
  }
});
function CardCarousel({
  cards,
  cardWidth,
  description,
  heading,
  headlineLineLength,
  id,
  isInfiniteScroll = false,
  isSmallControls,
  moveToLastCard,
  nextButtonAriaLabel = 'Next card',
  parentWidth,
  prevButtonAriaLabel = 'Previous card',
  showControls = true,
  showMobileControls = false,
  showOverflow = false
}) {
  const slidesRef = (0, _react.useRef)();
  const [containerWidth, setContainerWidth] = (0, _react.useState)(0);
  const [slidesWidth, setSlidesWidth] = (0, _react.useState)(0);
  const [slideCardWidth, setSlideCardWidth] = (0, _react.useState)(0);
  const [disableNext, setDisableNext] = (0, _react.useState)(false);
  const [disablePrev, setDisablePrev] = (0, _react.useState)(true);
  const [gapSize, setGapSize] = (0, _react.useState)(0);
  const {
    width
  } = (0, _patternLibraryUtils.useWindowSize)();
  const dir = () => {
    if (slidesRef?.current) {
      return (0, _functions.w)()?.getComputedStyle(slidesRef.current).direction;
    }
  };
  (0, _react.useEffect)(() => {
    const slider = slidesRef.current;
    const cw = cardWidth || slider?.children[0]?.clientWidth;
    const innerWidth = moveToLastCard ? cardWidth : parentWidth || (0, _functions.w)()?.innerWidth;
    setSlidesWidth(slider.clientWidth);
    setContainerWidth(innerWidth);
    setSlideCardWidth(cw);
    setGapSize((0, _functions.extractNum)((0, _functions.w)()?.getComputedStyle(slider).getPropertyValue('column-gap')));
    if (innerWidth >= slider.clientWidth && !showMobileControls) {
      setDisableNext(true);
      setDisablePrev(true);
    }
  }, [width]);
  const setTranslateX = (element, value) => {
    element.style.transform = `translateX(${value}px)`;
  };
  const handlePrevButtonClick = () => {
    const xPosition = (0, _functions.translateXForElement)(slidesRef.current);
    let newXPosition = xPosition + slideCardWidth + gapSize;
    const endPoint = (0, _functions.getEndPoint)({
      side: 'right',
      direction: dir(),
      containerWidth,
      slidesWidth
    });
    newXPosition = newXPosition > endPoint ? endPoint : newXPosition;
    setTranslateX(slidesRef.current, newXPosition);
    const disable = newXPosition === endPoint;
    setDisablePrev(dir() !== 'rtl' && disable);
    setDisableNext(dir() === 'rtl' && disable);
  };
  const handleNextButtonClick = () => {
    const xPosition = (0, _functions.translateXForElement)(slidesRef.current);
    let isEndPointReached = false;
    let newXPosition = xPosition - slideCardWidth - gapSize;
    const gapToEnd = isInfiniteScroll ? gapSize : slideCardWidth;
    const endPoint = (0, _functions.getEndPoint)({
      side: 'left',
      direction: dir(),
      containerWidth,
      slidesWidth
    });
    newXPosition = newXPosition < endPoint ? endPoint : newXPosition;
    const adjustedPosition = newXPosition - gapToEnd < endPoint ? endPoint : newXPosition;
    isEndPointReached = adjustedPosition === endPoint;
    if (isInfiniteScroll && isEndPointReached) {
      setDisablePrev(true);
      setTranslateX(slidesRef.current, 0);
    } else {
      setTranslateX(slidesRef.current, newXPosition);
      const disable = isEndPointReached;
      setDisablePrev(dir() === 'rtl' && disable);
      setDisableNext(dir() !== 'rtl' && disable);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    padding: "none",
    id: id,
    dataCy: 'card-carousel',
    showOverflow: showOverflow
  }, heading && /*#__PURE__*/_react.default.createElement(CarouselHeader, null, /*#__PURE__*/_react.default.createElement(_index.default, {
    headlineSize: "h3",
    headlineTag: "h2",
    heading: heading,
    description: description,
    textAlign: "start",
    headlineLineLength: headlineLineLength
  })), !heading && /*#__PURE__*/_react.default.createElement("div", null), /*#__PURE__*/_react.default.createElement(CarouselWrapper, {
    id: "carousel-wrapper",
    ref: slidesRef,
    showMobileControls: showMobileControls
  }, cards), showControls && /*#__PURE__*/_react.default.createElement(StyledCarouselControls, null, /*#__PURE__*/_react.default.createElement(_CarouselControls.default, {
    prevButtonAriaLabel: prevButtonAriaLabel,
    nextButtonAriaLabel: nextButtonAriaLabel,
    prevCallback: dir() === 'rtl' ? handleNextButtonClick : handlePrevButtonClick,
    nextCallback: dir() === 'rtl' ? handlePrevButtonClick : handleNextButtonClick,
    disablePrev: disablePrev,
    disableNext: disableNext,
    containerWidth: true,
    slidesWidth: true,
    isSmallControls: isSmallControls,
    showMobileControls: showMobileControls
  })));
}
CardCarousel.propTypes = {
  cards: _propTypes.default.arrayOf(_propTypes.default.element).isRequired,
  cardWidth: _propTypes.default.number,
  description: _propTypes.default.string,
  heading: _propTypes.default.string,
  headlineLineLength: _propTypes.default.number,
  id: _propTypes.default.string,
  isInfiniteScroll: _propTypes.default.bool,
  isSmallControls: _propTypes.default.bool,
  moveToLastCard: _propTypes.default.bool,
  nextButtonAriaLabel: _propTypes.default.string,
  prevButtonAriaLabel: _propTypes.default.string,
  supplement: _propTypes.default.node,
  showControls: _propTypes.default.bool,
  showMobileControls: _propTypes.default.bool,
  showOverflow: _propTypes.default.bool,
  parentWidth: _propTypes.default.number
};